<template>
	<div class="nav">
		<nav>
			<div class="nav-left">
				<img src="../assets/images/logo.png" alt="" class="img_logo">
			</div>
			<div class="nav-right">
				<div class="nav-li" :class="currentPage=='home' ? 'active': ''">
					<router-link :to="{path: 'home'}">首页</router-link>
				</div>
				<div class="nav-li" :class="currentPage == 'product' ? 'active' : ''" @mousemove="showProducts" @mouseout="removeShow">
					<a>产品</a>
					<transition>
						<div class="products" v-if="isShow">
							<div class="flexbox">
								<div class="pitem">
									<router-link :to="{path: 'cloud'}">
										<img src="../assets/images/home-picon-yun.png" alt="" class="home-picon picon-yun">
										<img src="../assets/images/home-picon-yunblue.png" alt="" class="home-picon picon-yun picon-yun-blue">
										<p>公共法律服务云平台</p>
									</router-link>
								</div>
								<div class="pitem">
									<router-link :to="{path: 'tiaojie'}">
										<img src="../assets/images/home-picon-tiaojie.png" alt="" class="home-picon picon-tiaojie">
										<img src="../assets/images/home-picon-tiaojieblue.png" alt="" class="home-picon picon-tiaojie-blue">
										<p>易调解</p>
									</router-link>
								</div>
								<div class="pitem">
									<router-link :to="{path: 'laywer'}">
										<img src="../assets/images/home-picon-ai.png" alt="" class="home-picon picon-ai">
										<img src="../assets/images/home-picon-aiblue.png" alt="" class="home-picon picon-yun picon-ai-blue">
										<p>AI+家庭律师</p>
									</router-link>
								</div>
								<div class="pitem">
									<router-link :to="{path: 'ai'}">
										<img src="../assets/images/home-picon-jiqiren.png" alt="" class="home-picon picon-jiqiren">
										<img src="../assets/images/home-picon-jiqirenblue.png" alt="" class="home-picon picon-jiqiren-blue">
										<p>AI法律机器人</p>
									</router-link>
								</div>
								<div class="pitem">
									<router-link :to="{path: 'qyfw'}">
										<img src="../assets/images/home-picon-fawu.png" alt="" class="home-picon picon-fawu">
										<img src="../assets/images/home-picon-fawublue.png" alt="" class="home-picon picon-fawu-blue">
										<p>企业法务体检</p>
									</router-link>
								</div>
								<div class="pitem">
									<router-link :to="{path: 'zscq'}">
										<img src="../assets/images/home-picon-zhishichanquan.png" alt="" class="home-picon picon-zhishichanquan">
										<img src="../assets/images/home-picon-zhishichanquanblue.png" alt="" class="home-picon picon-zhishichanquan-blue">
										<p>知识产权综合法律</p>
									</router-link>
								</div>
								<div class="pitem">
									<router-link :to="{path: 'xqyc'}">
										<img src="../assets/images/home-picon-xingqi.png" alt="" class="home-picon picon-xingqi picon-xingqi">
										<img src="../assets/images/home-picon-xingqiblue.png" alt="" class="home-picon picon-xingqi picon-xingqi-blue">
										<p>智能刑期预测系统</p>
									</router-link>
								</div>
							</div>
						</div>
					</transition>
				</div>
				<div class="nav-li" :class="currentPage == 'demo' ? 'active' : ''">
					<router-link :to="{path: 'demo'}">合作单位</router-link>
				</div>
				<div class="nav-li" :class="currentPage == 'about' ? 'active' : ''">
					<router-link :to="{path: 'about'}">关于我们</router-link>
				</div>
				<div class="nav-li" :class="currentPage == 'concat' ? 'active' : ''">
					<a class="concat-a">
						联络
						<div class="products concat">
							<div class="flexbox">
								<div class="pitem">
									<img src="../assets/images/dingwei.png" alt="" class="img_dingwei">
									<p>厦门市东合信息技术有限公司</p>
									<p>厦门市海沧区SEC泰地海西中心A703</p>
								</div>
								<div class="pitem">
									<img src="../assets/images/shichang.png" alt="" class="img_shichang">
									<p>市场部</p>
									<p>zhuxt@danhar.com</p>
								</div>
								<div class="pitem">
									<img src="../assets/images/tel.png" alt="" class="img_tel">
									<p>联系电话</p>
									<p style="font-size: 15px;">400-0592-110</p>
								</div>
							</div>
						</div>
					</a>
				</div>
			</div>

		</nav>
	</div>
</template>

<script>
export default {
  name: 'Nav',
  props: ['currentPage'],
  data() {
    return {
      isShow: false,
      isShowConcat: false
    }
  },
  methods: {
    showProducts() {
      this.isShow = true
    },
    removeShow() {
      this.isShow = false
    },
    showConcat() {
      this.isShowConcat = true
    },
    removeConcat() {
      this.isShowConcat = false
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.nav {
	width: 1200px;
	margin: 0 auto;
	nav {
		display: flex;
		flex-direction: row;
		justify-content: space-around;
		margin: 32px 0 12px;
		position: relative;
		.nav-left {
			// height: 62px;
			height: 40px;
			margin: 18px 0;
			.img_logo {
				// width: 366px;
				// height: 62px;
				width: 346px;
				height: 40px;
				margin: auto;
			}
		}
		.nav-right {
			flex: 0 0 740px;
			height: 62px;
			display: flex;
			flex-direction: row;
			justify-content: space-around;
			.nav-li {
				padding: 0px 18px;
				line-height: 28px;
				margin-top: 32px;
				border: 1px solid #fff;
				cursor: pointer;
				position: relative;
				a {
					display: block;
					font-size: 15px;
					color: #000;
					text-decoration: none;
					transition: all 0.3s ease-in;
				}
				.concat-a {
					transition: all 0.3s ease-in;
					.concat {
						display: none;
					}
				}
				.concat-a:hover {
					.concat {
						display: block;
					}
				}
			}
			.nav-li.active {
				background: #2392f4;
				border-radius: 20px;
				a {
					color: #fff;
				}
			}
			.nav-li.active:hover {
				a {
					color: #fff;
				}
				border: 1px solid #fff;
			}
			.nav-li:hover {
				border: 1px solid #2392f4;
				border-radius: 20px;
				font-size: 15px;
				a {
					color: #2392f4;
				}
				.products {
					a {
						color: #000;
					}
				}
			}
		}
		.showClass {
			display: block;
		}
		.noShow {
			display: none;
		}
		.products {
			z-index: 999;
			position: absolute;
			top: 30px;
			left: -912%;
			width: 1200px;
			background: #fff;
			box-shadow: -3px 6px 7px 1px rgba(112, 111, 111, 0.29);
			cursor: pointer;
			.flexbox {
				display: flex;
				flex-direction: row;
				justify-content: center;
			}
			.pitem:last-child {
				border-right: none;
			}
			.pitem a:hover {
				transform: translateY(-5px);
				.picon-tiaojie {
					display: none;
				}
				.picon-tiaojie-blue {
					display: block;
				}

				.picon-fawu {
					display: none;
				}
				.picon-fawu-blue {
					display: block;
				}

				.picon-yun {
					display: none;
				}
				.picon-yun-blue {
					display: block;
				}

				.picon-ai {
					display: none;
				}
				.picon-ai-blue {
					display: block;
				}

				.picon-jiqiren {
					display: none !important;
				}
				.picon-jiqiren-blue {
					display: block;
				}

				.picon-zhishichanquan {
					display: none;
				}
				.picon-zhishichanquan-blue {
					display: block;
				}

				.picon-xingqi {
					display: none;
				}
				.picon-xingqi-blue {
					display: block;
				}
			}
			.pitem {
				flex: 1;
				border-right: 1px solid #dcdcdc;
				margin: 10px 0 20px;
				text-align: center;
				position: relative;
				a {
					display: block;
					text-decoration: none;
					color: #000000;
					transition: all 0.3s ease-in;
				}
				.home-picon {
					margin: 10px auto 8px;
					width: 28px;
					height: 34px;
				}
				.picon-tiaojie {
					margin: 10px auto 12px;
					width: 39px;
					height: 35px;
					display: block;
				}
				.picon-tiaojie-blue {
					margin: 10px auto 12px;
					width: 39px;
					height: 35px;
					display: none;
				}

				.picon-fawu {
					width: 42px;
					height: 40px;
					display: block;
				}
				.picon-fawu-blue {
					width: 42px;
					height: 40px;
					display: none;
				}

				.picon-yun {
					margin: 10px auto 13px;
					width: 51px;
					height: 34px;
					display: block;
				}
				.picon-yun-blue {
					margin: 10px auto 13px;
					width: 51px;
					height: 34px;
					display: none;
				}

				.picon-ai {
					margin: 10px auto 14px;
					width: 32px;
					height: 32px;
					display: block;
				}
				.picon-ai-blue {
					margin: 10px auto 14px;
					width: 32px;
					height: 32px;
					display: none;
				}

				.picon-jiqiren {
					margin: 10px auto 14px;
					width: 32px;
					height: 32px;
					display: block;
				}
				.picon-jiqiren-blue {
					margin: 10px auto 14px;
					width: 32px;
					height: 32px;
					display: none;
				}

				.picon-zhishichanquan {
					margin: 10px auto 6px;
					width: 50px;
					height: 43px;
					display: block;
				}
				.picon-zhishichanquan-blue {
					margin: 10px auto 6px;
					width: 50px;
					height: 43px;
					display: none;
				}

				.picon-xingqi {
					margin: 10px auto 14px;
					width: 28px;
					height: 34px;
					display: block;
				}
				.picon-xingqi-blue {
					margin: 10px auto 14px;
					width: 28px;
					height: 34px;
					display: none;
				}
			}
		}
		.concat {
			top: 29px;
			left: -1075px;
			.pitem:nth-child(2) {
				p {
					padding-left: 150px;
				}
			}
			.pitem:last-child {
				p {
					padding-left: 150px;
				}
			}
			.pitem {
				margin: 30px auto 30px;
				p {
					font-size: 13px;
					color: #898a8b;
					margin-bottom: 4px;
					text-align: left;
					padding-left: 124px;
					line-height: 22px;
				}
			}
			.img_dingwei {
				position: absolute;
				top: 0;
				left: 74px;
				width: 34px;
				height: 40px;
			}
			.img_shichang {
				position: absolute;
				top: 3px;
				left: 95px;
				width: 35px;
				height: 33px;
			}
			.img_tel {
				position: absolute;
				top: 2px;
				left: 100px;
				width: 34px;
				height: 34px;
			}
		}
	}
}
@media screen and (max-width: 998px) and (min-width: 768px) {
	.nav {
		width: 910px !important;
		margin: 0 auto;
		nav {
			display: flex;
			flex-direction: row;
			justify-content: space-around;
			margin: 22px 0 12px;
			position: relative;
			.nav-left {
				height: 62px;
				.img_logo {
					width: 292px;
					height: 50px;
				}
			}
			.nav-right {
				flex: 0 0 618px;
				height: 50px;
				.nav-li {
					padding: 10px 18px;
					line-height: 3px;
					margin-top: 32px;
					a {
						font-size: 13px;
					}
				}
				.nav-li:hover {
					font-size: 13px;
				}
			}
			.products {
				top: 26px;
				left: -695%;
				width: 910px;
			}
		}
	}
}
</style>
